import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as NumberSvg } from "@/svgs/number.svg?react";

export default function NumberIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={NumberSvg} inheritViewBox />;
}
